import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Box, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { useField } from 'react-final-form';

export const CheckboxAdapter = ({
  input: { name, onChange, ...restInput },
  label,
  tooltip,
  ...rest
}: any) => {
  const { input, meta } = useField(name);

  const hasError = Boolean(meta.touched && meta.error);

  return (
    <Box sx={{ width: '100%', minHeight: 56, display: 'flex', alignItems: 'center' }}>
      <FormControlLabel
        sx={{
          m: 0,
          width: '100%',
          minHeight: 44,
          px: 0.5,
          borderRadius: 1.5,
          transition: 'background-color 120ms ease',

          '&:hover': {
            backgroundColor: 'action.hover'
          },

          '&:focus-within': {
            backgroundColor: 'action.selected'
          },

          '& .MuiFormControlLabel-label': {
            flex: 1,
            color: hasError ? 'error.main' : 'text.primary',
            fontSize: '0.875rem',
            lineHeight: 1.4
          },

          '& .MuiCheckbox-root': {
            p: 0.75
          },

          // Tooltip icon hidden until the row is hovered
          '&:hover .checkbox-tooltip-icon': {
            opacity: 1,
            pointerEvents: 'auto'
          }
        }}
        control={
          <Checkbox
            {...rest}
            {...restInput}
            name={name}
            checked={Boolean(input.value)}
            onChange={(event) => onChange(event.target.checked)}
            color={hasError ? 'error' : 'primary'}
            inputProps={{
              'aria-invalid': hasError || undefined
            }}
          />
        }
        label={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              gap: 0.75
            }}>
            <Box component="span">{label}</Box>

            {tooltip && (
              <Tooltip title={tooltip} placement="top" enterDelay={300}>
                <Box
                  component="span"
                  className="checkbox-tooltip-icon"
                  onClick={(event) => event.stopPropagation()}
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    flexShrink: 0,
                    ml: 'auto',
                    opacity: 0,
                    pointerEvents: 'none',
                    color: 'grey.300',
                    cursor: 'help',
                    transition: 'opacity 150ms ease, color 150ms ease',

                    '&:hover': {
                      color: 'grey.500'
                    }
                  }}>
                  <HelpOutlineOutlinedIcon sx={{ fontSize: 15 }} />
                </Box>
              </Tooltip>
            )}
          </Box>
        }
      />
    </Box>
  );
};
